// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer-module--Footer--3zV-a","Copyright":"Footer-module--Copyright--33ZfY","SocialMedia":"Footer-module--SocialMedia--2-dWr","Repo":"Footer-module--Repo--14Cws"};